import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const LinkWrapper = styled(Link)`
    text-decoration: ${props => props.type === 'button' ? 'none' : 'underline'};
    font-size: ${props => props.type === 'button' ? '14px' : '18px'};
    color: ${props => props.type === 'button' ? 'black' : 'blue'};
    letter-spacing: 0.5px;
    font-weight: 300;
    width: 100%;
`

const CompanyPageLink = ({ label, destination, type }) => {
    return(
        <LinkWrapper 
            to={destination} 
            type={type}
        >
            {label}
        </LinkWrapper>
    )
}

CompanyPageLink.propTypes = {
    /** Label to be displayed as the title of the label */
    label: PropTypes.string.isRequired,
    /** Link destination for routing purposes */
    destination: PropTypes.string.isRequired,
    /** Type string used for link styling */
    type: PropTypes.string
}

CompanyPageLink.defaultProps = {
    label: 'Placeholder label',
    destination: '/Place/holder',
    type: 'button'
}

export default CompanyPageLink;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CompanyPageLink.jsx